import { OtherConcerns } from "./v1";

export type OtherConcernsV1Type = keyof typeof OtherConcerns;
export type OtherConcernsType = OtherConcernsV1Type;
